export default __webpack_public_path__ + "static/media/gr.73e55c30.svg";